import { Factory } from './index';
import { type ApiAcademicYear, AcademicYear } from '@/types/academicYears';

export class AcademicYearFactory extends Factory<AcademicYear> {
  private index = -2; // Start 2 years before current year
  private startOffset = -2; // Default starting offset

  constructor(startYearsBack: number = 2) {
    super();
    this.startOffset = -startYearsBack;
    this.index = this.startOffset;
  }

  protected definition(): AcademicYear {
    const currentYear = new Date().getFullYear();
    const year = currentYear + this.index;
    const nextYear = year + 1;

    this.index++;

    const apiAcademicYear: ApiAcademicYear = {
      uuid: `${year}-${nextYear}`,
      name: `${year}-${nextYear}`,
      start_date: `${year}-07-01`,
      end_date: `${nextYear}-06-30`,
    };

    return new AcademicYear(apiAcademicYear);
  }

  public createManySorted(count: number): AcademicYear[] {
    return this.createMany(count).sort((a, b) => a.startDate.localeCompare(b.startDate));
  }

  /**
   * Create academic years starting from a specific number of years before the current year
   * @param count - Number of academic years to create
   * @param startYearsBack - How many years before current year to start (default: 2)
   */
  public static createManySortedFromYearsBack(count: number, startYearsBack: number = 2): AcademicYear[] {
    const factory = new AcademicYearFactory(startYearsBack);
    return factory.createManySorted(count);
  }
}
